import React from "react";
import "./prohibited-unconfirmed-email.scss";
import DefaultModal from "../DefaultModal";
import { useTranslation } from "react-i18next";
import imgUnverified from "../profile/unverified.png";
import CusButton from "../../mui/custom_button/CusButton";
import { useDispatch } from "react-redux";
import { setModalProfile } from "../../../store/siteSlice";

export default function ProhibitedUnconfirmedEmailModal({
  isOpen,
  closeModal,
  title = "Action prohibited"
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const openProfile = () => {
    closeModal();
    dispatch(setModalProfile(true));
  };

  return (
    <DefaultModal
      miniModal
      isOpen={isOpen}
      closeModal={closeModal}
      classModal="prohibited-unconfirmed-email-modal">
      <h2>{t(title)}</h2>
      <div className="prohibited-unconfirmed-email__content">
        <div className="prohibited-unconfirmed-email__info">
          <div className="prohibited-unconfirmed-email__info__text">
            <img
              src={imgUnverified}
              alt="unverified"
              className="prohibited-unconfirmed-email__info__img"
            />
            <p>{t("To remove restrictions, confirm your email address!")}</p>
          </div>
          <div className="prohibited-unconfirmed-email__info__container">
            <button onClick={openProfile}>{t("Click here")}</button>
            <p className="prohibited-unconfirmed-email__info__text__p">
              <span>{t("to confirm your email!")}</span>
            </p>
          </div>
        </div>
        <CusButton
          onClick={openProfile}
          className="open-profile"
          text={"Open profile"}
          color="gradient-blue"
        />
      </div>
    </DefaultModal>
  );
}
